import React from "react";
import PropTypes from "prop-types";
import Tooltip from "@mui/material/Tooltip";
import "./ChargerDisplay.scss";

function ChargerDisplay({ serialNumber, onClick, showSidePanel = true }) {
  if (!serialNumber) return "-";

  return (
    <div className="ocpp-charger-display">
      IQ EV Charger:{" "}
      {showSidePanel ? (
        <Tooltip title="View charger details" arrow placement="right">
          <button
            type="button"
            className="ocpp-charger-serial"
            onClick={onClick}
            aria-label={`View charger details for ${serialNumber}`}
          >
            {serialNumber}
          </button>
        </Tooltip>
      ) : (
        <span className="ocpp-charger-serial-without-side-panel">{serialNumber}</span>
      )}
    </div>
  );
}

ChargerDisplay.propTypes = {
  serialNumber: PropTypes.string,
  onClick: PropTypes.func,
  showSidePanel: PropTypes.bool,
};

export default ChargerDisplay;
